import { useAppStore } from '@/stores/AppStore'
import {
  ClinicBranch
} from '@/type/Clinic'
import http from '@/services/http'

export function useBranchRepository(clinic_uuid: string) {
  const appStore = useAppStore()

  /**
   * Fetch branch list from filter type condition
   * filterType?: 'sell_branch' | 'appointment'
   *
   * if not filterType, return all branch list on this OA
   */
  async function fetchBranchList(filterType: string): Promise<ClinicBranch[]> {
    const response = await http.get(
      `${appStore.url}/api/v1/crm/line-app/p/branch/`,
      {
        // todo change liff_id to appStore.liffId
        params: { c: clinic_uuid, liffId: appStore.liffId, filterType: filterType, },
      },
    )

    return response.data
  }

  return {
    fetchBranchList,
  }
}
